import React from 'react';
import { Typography } from '@material-ui/core';
import { useResources } from 'resources';
import { useStyles } from './cardapio-footer-styles';
import { TemaModel } from 'api/cardapio/models/tema/tema-model';
import { EmpresaModel } from 'api/cardapio/models/empresa/empresa-model';

interface CardapioFooterProps {
  capa?: TemaModel['capa'];
  logo?: TemaModel['logo'];
  nomeFantasia?: EmpresaModel['nomeFantasia'];
}

export const CardapioFooter = ({ capa, logo, nomeFantasia }: CardapioFooterProps) => {
  const props = {
    capa: capa
  }
  const classes = useStyles(props);
  const resources = useResources();

  return (
    <footer className={classes.footer}>
      <div
        className={classes.footerBg}
      ></div>
      <div className={classes.containerEmpresa}>
        <div>
          <Typography variant="body2" align="left" color="textSecondary" style={{ marginTop: -5 }}>
            {resources.paginas.cardapioFooter.textoFooter}
          </Typography>
        </div>
      </div>
    </footer>
  );
};
